import React from "react";
import { withRouter } from "react-router-dom";
import { config } from "../../config/config";
import { login } from "../../services/authenticationService";
import {
  HeadingStyled,
  ContainerStyled,
  ButtonsGroupStyled,
  KeyButtonStyledBack,
  KeyButtonStyledNext,
  TextStyled
} from "../../styles/shared-styles";
import { LoginPageStyled, BlockLoginStyled } from "./styles/Styled";
import { Text, Input, KeyboardSwap, withFocusable, Loading } from "../../services/visualLibraryService";
import { withAppState, getAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { getSdk } from "../../services/sdkService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { getInternetConnectivityModalConfig, getLoginErrorModalConfig } from "../../errors/utils";
import { showSingleModalButton } from "../../services/modalsService";
import { getLoginRedirectionData } from "../../services/navigationService";
import { redirectTo } from "../../services/navigationService";
import { historyMethods } from "../../utils/historyMethods";
import { routes } from "../../routes";

import { isAnyAddonStatusActive } from "../../utils/subscriptionUtils";

const KeyButtonStyledBackFocus = withFocusable(KeyButtonStyledBack);
const KeyButtonStyledNextFocus = withFocusable(KeyButtonStyledNext);
const KeyButtonStyledShowHideFocus = withFocusable(KeyButtonStyledNext);

const TYPE_PASSWORD = "password";
const TYPE_TEXT = "text";
const PAGE = "login";

function handleRequestError(error) {
  const { stateActions } = this.props;
  if (error.status === 403 || error.status === 401) {
    stateActions.showGlobalModal(getLoginErrorModalConfig.call(this, {}));
  } else if (error.status === 400) {
    stateActions.showGlobalModal(getLoginErrorModalConfig.call(this, {}));
  } else if (getAppState().isOnline && error.message.indexOf("timeout") > -1) {
    stateActions.showGlobalModal(
      getInternetConnectivityModalConfig({
        retryImplementation: this.closeModal,
        backImplementation: this.closeModal,
        customButtons: showSingleModalButton("close", this.closeModal),
        needsDismissableProp: false,
        isTimeout: true
      })
    );
  } else if (!getAppState().isOnline) {
    stateActions.showGlobalModal(
      getInternetConnectivityModalConfig({
        retryImplementation: this.closeModal,
        backImplementation: this.closeModal,
        customButtons: showSingleModalButton("close", this.closeModal),
        needsDismissableProp: false
      })
    );
  } else {
    stateActions.showGlobalModal({
      modalText: i18n.get("global.errors.genericError"),
      buttons: showSingleModalButton("close", this.closeModal)
    });
  }
}

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.userInput = React.createRef();
    this.pwdInput = React.createRef();
    this.loginModalFocusPath = "backModalButton";
    this.state = {
      user: "",
      pwd: "",
      active: this.userInput,
      passInputType: TYPE_PASSWORD,
      isLoggingIn: false
    };
    this.sendLogin = this.sendLogin.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.activateUserInput = this.activateUserInput.bind(this);
    this.activatePasswordInputOrLogin = this.activatePasswordInputOrLogin.bind(this);
    this.changePassInputType = this.changePassInputType.bind(this);
    this.keyboardDidSwap = this.keyboardDidSwap.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onBack = this.onBack.bind(this);
    this.mounted = false;
  }

  componentDidMount() {
    const { history, onRef, signupUsername } = this.props;
    if (signupUsername) {
      this.setState({ user: signupUsername });
      this.activatePasswordInputOrLogin();
    }
    const hasHistoryState = !!(history.location && history.location.state);
    trackPage(PAGE);
    onRef && onRef(this);
    hasHistoryState &&
      history.location.state.user &&
      this.setState({
        user: history.location.state.user,
        active: this.pwdInput
      });
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.currentFocus !== this.props.currentFocus ||
      nextState.user !== this.state.user ||
      nextState.pwd !== this.state.pwd ||
      nextState.active.current !== this.state.active.current ||
      nextState.passInputType !== this.state.passInputType ||
      nextState.isLoggingIn !== this.state.isLoggingIn
    );
  }

  async sendLogin() {
    const { user, pwd } = this.state;
    const { stateActions, history } = this.props;
    const appState = getAppState();
    const { voucherData } = getAppState();
    const sdk = await getSdk();
    console.log("LOgin voucherData", voucherData);
    let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);
    try {
      await sdk.mediaManager.clearLayoutCache();
      this.setState({ isLoggingIn: true });
      // TODO: To improve the way of error handling with axios error response from the SDK request rejection
      const userLoggedRequest = await login(user, pwd, !getAppState().isOnline);
      trackEvent(PAGE, "success", "success");
      getAppState().userAddonStatus = isAnyAddonStatusActive(userLoggedRequest?.settings?.addons);
      getAppState().userAccountStatus = userLoggedRequest?.settings?.accountStatus;
      stateActions.userLoggedIn(userLoggedRequest);

      if (voucherData) {
        trackEvent("session_start", PAGE, "session_start", userLoggedRequest);

        redirectTo.call(this, routes.promotions, null, historyMethods.REPLACE);
        return;
      }
      trackEvent("session_start", PAGE, "session_start", userLoggedRequest);
      redirectTo.call(this, routes.profileSelector, { nextPageReference: redirectPath }, navigationMode);
      sdk.userManager.getDevices();
    } catch (e) {
      if (this.mounted) {
        this.setState({ isLoggingIn: false });
        trackEvent(PAGE, "error", `${e.status} ${e.message}`);
        handleRequestError.call(this, e);
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      }
    }
  }

  closeModal() {
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(KeyboardSwap.defaultFocusPath);
  }

  activateUserInput() {
    this.setState({
      active: this.userInput
    });
  }

  activatePasswordInputOrLogin() {
    if (
      this.state.user.length &&
      this.state.pwd.length >= config.get().minPassLength &&
      !!this.state.pwd.length &&
      this.state.active === this.pwdInput
    ) {
      this.sendLogin();
    } else {
      const currentDirection = i18n.getDirection().toUpperCase();
      const initialDefaultFocus = KeyboardSwap[`defaultFocusPath${currentDirection}`];
      this.setState({
        active: this.pwdInput
      });
      this.props.setFocus(initialDefaultFocus);
    }
  }

  updateValue(value) {
    if (this.state.active === this.userInput && this.state.user !== value) {
      this.setState({ user: value });
    } else if (this.state.active === this.pwdInput && this.state.pwd !== value) {
      this.setState({ pwd: value });
    }
  }

  checkLoginButtonDisability() {
    return (
      (this.state.active === this.userInput && !this.state.user.length) ||
      (this.state.active === this.pwdInput && this.state.pwd.length < config.get().minPassLength)
    );
  }

  changePassInputType() {
    this.setState({
      passInputType: this.state.passInputType === TYPE_TEXT ? TYPE_PASSWORD : TYPE_TEXT
    });
    this.state.passInputType === TYPE_PASSWORD && trackEvent(PAGE, "show password", "show password");
  }

  keyboardDidSwap({ defaultFocusPath }) {
    this.props.setFocus(defaultFocusPath);
  }

  onBack() {
    const { history } = this.props;
    const hasHistoryState = !!(history.location && history.location.state);
    if (hasHistoryState && history.location.state.backDestination) {
      const backDestination = history.location.state.backDestination;
      const backDestinationPathname = backDestination.pathname || backDestination;
      if (backDestinationPathname === routes.welcome) {
        redirectTo.call(this, routes.pin, history.location.state, historyMethods.REPLACE);
      } else {
        history.replace(backDestinationPathname, { from: { name: "/home" } });
        return true;
      }
    }
    redirectTo.call(this, routes.pin, null, historyMethods.REPLACE);
    return true;
  }

  render() {
    return (
      <LoginPageStyled>
        <HeadingStyled rank={1} text={i18n.get("pages.login.title")} />
        <Text text={i18n.get("global.credentials.enterCredentials")} />
        <ContainerStyled>
          <BlockLoginStyled>
            <KeyboardSwap
              text={this.state.active === this.userInput ? this.state.user : this.state.pwd}
              onChange={this.updateValue}
              direction={i18n.getDirection()}
              onSwap={this.keyboardDidSwap}
            />
            <ButtonsGroupStyled>
              <KeyButtonStyledBackFocus onClick={this.activateUserInput} focusPath={"loginBackButton"}>
                {i18n.get("global.back")}
              </KeyButtonStyledBackFocus>

              <KeyButtonStyledNextFocus
                onClick={this.activatePasswordInputOrLogin}
                focusPath={"loginNextButton"}
                disabled={this.checkLoginButtonDisability()}
              >
                {this.state.active === this.pwdInput ? i18n.get("pages.login.title") : i18n.get("global.next")}
              </KeyButtonStyledNextFocus>
            </ButtonsGroupStyled>

            {this.state.active === this.pwdInput && (
              <KeyButtonStyledShowHideFocus
                onClick={this.changePassInputType}
                focusPath={"showHidePassword"}
                icon={this.state.passInputType === TYPE_TEXT ? "hide" : "show"}
              >
                {this.state.passInputType === TYPE_TEXT
                  ? i18n.get("global.credentials.hidePassword")
                  : i18n.get("global.credentials.showPassword")}
              </KeyButtonStyledShowHideFocus>
            )}
          </BlockLoginStyled>
          <BlockLoginStyled>
            <Input
              id={"login-user-input"}
              type="text"
              ref={this.userInput}
              value={this.state.user}
              placeholder={i18n.get("global.credentials.example.emailAndPhone")}
              active={this.state.active === this.userInput}
              readOnly
            />
            <Input
              id={"login-password-input"}
              type={this.state.passInputType}
              ref={this.pwdInput}
              value={this.state.pwd}
              placeholder={i18n.get("global.credentials.password")}
              active={this.state.active === this.pwdInput}
              readOnly
            />
          </BlockLoginStyled>
        </ContainerStyled>
        <TextStyled type="secondary" text={i18n.get("pages.login.toCreateAccount")} />

        {this.state.isLoggingIn && <Loading overlay />}
      </LoginPageStyled>
    );
  }
}

const Login = withRouter(
  withAppState(
    withSubtheme(({ history, applicationState, stateActions, setFocus, onRef }) => (
      <LoginPage
        history={history}
        currentFocus={applicationState.currentFocus}
        stateActions={stateActions}
        setFocus={setFocus}
        signupUsername={applicationState.signupUsername}
        onRef={onRef}
      />
    ))
  )
);

Login.defaultFocusPathLTR = KeyboardSwap.defaultFocusPathLTR;
Login.defaultFocusPathRTL = KeyboardSwap.defaultFocusPathRTL;
Login.defaultFocusPath = KeyboardSwap.defaultFocusPath;

export default Login;
